import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '@reveni-io/reveni-ui'

import { decodeAndDownloadFile } from '@/common/helpers/helpers'
import { getRelatedIds } from '@/parcels/pages/ParcelsPage/pages/ParcelsListPage/helpers'
import parcelServices from '@/parcels/services/services'

import { getPreparableParcels } from './helpers'

const usePrepareParcels = ({ storeId, setToastInfo, refetch, setSelectedParcels, selectedParcels }) => {
  const { t } = useTranslation()

  const [showPrepareParcelsModal, setShowPrepareParcelsModal] = useState(false)
  const [showPrepareParcelsErrorModal, setShowPrepareParcelsErrorModal] = useState(false)
  const [failedParcels, setFailedParcels] = useState([])

  const { fetchData: prepareParcelsRequest, loading: preparingParcels } = useFetch(parcelServices.prepareParcels, {
    doInitialRequest: false,
  })

  const openPrepareParcelsModal = () => {
    setShowPrepareParcelsModal(true)
  }

  const closePrepareParcelsModal = () => {
    setShowPrepareParcelsModal(false)
  }

  const openPrepareParcelsErrorModal = () => {
    setShowPrepareParcelsErrorModal(true)
  }

  const closePrepareParcelsErrorModal = () => {
    setShowPrepareParcelsErrorModal(false)
  }

  const getParcelsByRelatedIds = relatedIds => {
    return selectedParcels?.filter(parcel => relatedIds.includes(parcel.related?.id))
  }

  const onPrepareParcels = async parcelIds => {
    try {
      const response = await prepareParcelsRequest({
        storeId,
        payload: { ids: getRelatedIds(selectedParcels, parcelIds) },
      })

      decodeAndDownloadFile({
        encodedFile: response?.file,
        fileName: `prepared-parcels-${new Date().getTime()}.pdf`,
        type: 'application/pdf',
        callback: () => setToastInfo({ show: true, message: t('Archivo descargado correctamente'), type: 'success' }),
      })

      setFailedParcels(getParcelsByRelatedIds(response?.failed_ids))
      closePrepareParcelsModal()
      refetch()
      setSelectedParcels([])

      if (response?.failed_ids.length > 0) {
        openPrepareParcelsErrorModal()
      }
    } catch (error) {
      closePrepareParcelsModal()
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    showPrepareParcelsModal,
    openPrepareParcelsModal,
    closePrepareParcelsModal,
    showPrepareParcelsErrorModal,
    openPrepareParcelsErrorModal,
    closePrepareParcelsErrorModal,
    preparingParcels,
    onPrepareParcels,
    failedParcels,
    preparableParcels: getPreparableParcels(selectedParcels),
  }
}

export default usePrepareParcels
